import { call, put, select } from 'redux-saga/effects';
import { Action } from '@reduxjs/toolkit';
import i18n from 'i18n';
import { addActionNotification } from 'features/notifications/action-notifications/addActionNotification';
import { signalingQuestionAsked } from 'features/qa/actions';
import { selectSidePanel, sidePanelOpened } from 'features/side-panels/sidePanelsSlice';
import { SidePanelType } from 'features/side-panels/types';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { FeatureFlag } from 'features/feature-set/types';

export function* onQuestionAskedSaga(action: ReturnType<typeof signalingQuestionAsked>) {
  if (action.payload.local) {
    // don't show the notification to the local user
    return;
  }

  const canModerate: boolean = yield call(hasPermissionsSaga, PermissionTypes.moderateQA);
  const canAnswer: boolean = yield call(hasPermissionsSaga, PermissionTypes.answerQA);
  const canSeeQuestionsAuthor: boolean = yield call(
    hasPermissionsSaga,
    PermissionTypes.seeQuestionsAuthor
  );

  const { id, question, user } = action.payload;

  if (canAnswer || canModerate) {
    const activePanel: SidePanelType = yield select(selectSidePanel);

    const showInitiator = canSeeQuestionsAuthor && user;
    const notificationContent = showInitiator
      ? i18n.t('notifications:qa.new_question_posted.content', {
          username: user.name,
          question,
        })
      : i18n.t('notifications:qa.new_question_posted.content_anonymous', {
          question,
        });

    const actionNotificationThunk: Action = yield call(
      addActionNotification,
      {
        content: notificationContent,
        okText: i18n.t('notifications:qa.new_question_posted.btn_ok_label'),
        okAction: sidePanelOpened('qa', {
          questionId: id,
        }),
        hideOkAction: activePanel === 'qa',
        ...(showInitiator && { initiatorId: user.id }),
        scope: [FeatureFlag.qa, 'question'],
        data: {
          questionId: id,
        },
      },
      {
        toastId: id,
      }
    );

    yield put(actionNotificationThunk);
  }
}
